import { createSlice, isAnyOf } from '@reduxjs/toolkit';

import { getChartsData, getMailSettings, getUserSettings, saveMailSettings, saveUserSettings } from './async';
import { initialState } from './settings';

export const settingsSlice = createSlice({
    name: 'settings',
    initialState,
    reducers: {},
    extraReducers: (builder) =>
        builder
            // todo выпилить и оставить общий запрос getUserSettings
            .addCase(getMailSettings.fulfilled, (s, { payload: { mailSettings } }) => {
                s.mailSettings = mailSettings;
                s.fetch = false;
            })
            .addCase(saveMailSettings.fulfilled, (s, { payload: { mailSettings } }) => {
                s.mailSettings = mailSettings;
            })
            .addMatcher(
                isAnyOf(getUserSettings.fulfilled, saveUserSettings.fulfilled, getChartsData.fulfilled),
                (s, { payload: { type, data } }) => {
                    s[type] = data;
                },
            ),
});
